import sessionHandler from 'core/controllers/sessionHandler'
import addAgencyIdAndExecuteFinishToRender from 'utils/addAgencyIdAndExecuteFinishToRender'

const saveSession = sessionHandler({
  useState: true,
  save: true
})

function finish() {
  addAgencyIdAndExecuteFinishToRender()
  return saveSession()
}

export default finish
